if (!customElements.get('navigation-tabs')) {
  customElements.define(
    'navigation-tabs',
    class NavigationTabs extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.triggers.forEach(element => {
          element.addEventListener('click', this.onChange.bind(this))
        })
      }

      disconnectedCallback() {
        this.triggers.forEach(element => {
          element.removeEventListener('click', this.onChange.bind(this))
        })
      }

      onChange(event) {
        const index = event.currentTarget.getAttribute('data-index') || '1'
        this.contents.forEach(element => {
          if (element.getAttribute('data-index') == index) {
            element.classList.add('active')
          } else {
            element.classList.remove('active')
          }
        })

        this.triggers.forEach(element => {
          if (element.getAttribute('data-index') == index) {
            element.classList.add('active')
          } else {
            element.classList.remove('active')
          }
        })
      }

      get triggers() {
        return this.querySelectorAll('[data-head-item]')
      }

      get contents() {
        return this.querySelectorAll('[data-content-item]')
      }
    }
  );
}
